import gql from 'graphql-tag'

export default gql`
  mutation createUser($firstName: String, $lastName: String, $email: String!, $password: String!, $roles: [RoleInput]) {
    createUser(firstName: $firstName, lastName: $lastName, email: $email, password: $password, roles: $roles) {
      id
      firstName
      lastName
      email
      roles {
        id
        name
      }
  }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/user/create.js